/** @type {Map<number, number> | null} Unicode code point → Windows-1251 byte */
let cp1251EncodeMap = null;

function getCp1251EncodeMap() {
    if (cp1251EncodeMap) return cp1251EncodeMap;
    cp1251EncodeMap = new Map();
    try {
        const decoder = new TextDecoder('windows-1251');
        for (let b = 0; b < 256; b += 1) {
            const ch = decoder.decode(new Uint8Array([b]));
            if (ch.length === 1) cp1251EncodeMap.set(ch.charCodeAt(0), b);
        }
    } catch {
        cp1251EncodeMap = new Map();
    }
    return cp1251EncodeMap;
}

/**
 * Repair UTF-8 Cyrillic that was decoded as Windows-1251 and stored as Unicode
 * (e.g. "Английский" → "РђРЅРіР»РёР№СЃРєРёР№").
 */
export function repairUtf8Mojibake(text) {
    if (typeof text !== 'string' || text.length < 4) return text;

    const map = getCp1251EncodeMap();
    if (!map.size) return text;

    try {
        const bytes = [];
        for (const ch of text) {
            const byte = map.get(ch.charCodeAt(0));
            if (byte === undefined) return text;
            bytes.push(byte);
        }
        const decoded = new TextDecoder('utf-8', { fatal: false }).decode(new Uint8Array(bytes));
        if (decoded.includes('\uFFFD') || !/[\u0400-\u04FF]/.test(decoded)) return text;
        if (decoded === text) return text;
        // Mojibake expands each UTF-8 byte into one Unicode character.
        if (decoded.length >= text.length) return text;
        return decoded;
    } catch {
        return text;
    }
}

export function repairSiteTextRows(rows) {
    if (!Array.isArray(rows)) return rows;
    return rows.map((row) => {
        if (!row?.content || typeof row.content !== 'string') return row;
        const content = repairUtf8Mojibake(row.content);
        return content === row.content ? row : { ...row, content };
    });
}
